// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trending-articles__title[data-v-f275aa78]{color:#fff;text-align:center;font-family:Anton,Anton-Fallback,Impact;font-size:22px;font-weight:400;line-height:32px;letter-spacing:.44px;width:-moz-fit-content;width:fit-content;margin-top:0}.article[data-v-f275aa78]{margin-inline-end:24px;width:368px}", ""]);
// Exports
module.exports = exports;
